import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import SourceDocumentsTab from "./SourceDocumentsTab";

let mockTranscriptsEnabled = true;

jest.mock("../../../../../providers/FeatureFlagProvider", () => ({
  useFeatureFlag: () => mockTranscriptsEnabled,
}));

jest.mock("../../../hooks/useDocumentSources", () => ({
  useDocumentSources: () => ({
    getSources: jest.fn().mockResolvedValue([]),
    loading: false,
    deleteSource: jest.fn(),
  }),
}));

jest.mock("../../../contexts/ValidationContext", () => ({
  useValidation: () => ({ setShowValidation: jest.fn() }),
}));

const transcriptSlot = {
  SourceFieldID: 7,
  Name: "interview",
  Label: "Interview transcript",
  DocumentType: "Transcript" as const,
  IsRequired: true,
  OrderIndex: 0,
};

describe("Transcript source role feature flag", () => {
  beforeEach(() => {
    mockTranscriptsEnabled = true;
  });

  it("offers the Transcript role when the workspace flag is on", () => {
    render(
      <SourceDocumentsTab
        documents={[{ ...transcriptSlot, DocumentType: "Source" }]}
        workspace_id="workspace-1"
        onChange={jest.fn()}
        showValidation={false}
      />,
    );

    fireEvent.click(screen.getByRole("combobox"));
    expect(
      screen.getByRole("option", { name: "Transcript" }),
    ).toBeInTheDocument();
  });

  it("does not offer Transcript and explains an existing slot when the flag is off", () => {
    mockTranscriptsEnabled = false;
    render(
      <SourceDocumentsTab
        documents={[transcriptSlot]}
        workspace_id="workspace-1"
        onChange={jest.fn()}
        showValidation={false}
      />,
    );

    expect(
      screen.getByText(
        /Transcript unavailable while Meridian transcripts are disabled/i,
      ),
    ).toBeInTheDocument();
    expect(
      screen.queryByRole("option", { name: "Transcript" }),
    ).not.toBeInTheDocument();
  });
});
